import { Controller } from "@hotwired/stimulus"

/**
 * IoT Accel Send Controller (CONEK-8053)
 *
 * Powers the Accelerometer tab's "Send configuration to the sensor" form
 * (packs/iot/app/views/iot/admin/sensor_nodes/_accel_send.html.erb). The Z
 * gate only counts with the "custom" preset: Standard and Sensitive carry
 * their own gate, so a number typed next to them used to be dropped while the
 * flash still said "queued".
 *
 * The gate field is shown and enabled only while "custom" is chosen. A
 * disabled input is left out of FormData, so the server never receives a gate
 * it would ignore, and the browser stops enforcing its min/max for it. The
 * typed value is kept, so switching back to "custom" restores it.
 *
 * The preset is a Ui::SelectComponent (Tom Select), which dispatches `change`
 * on the native <select>, so a plain data-action is enough. connect() syncs
 * too, for a form the browser restored with "custom" already selected.
 *
 * The view hides the wrapper (`field`) rather than passing `disabled: true`
 * to the component: Ui::InputComponent then puts pointer-events-none on its
 * container, which re-enabling the <input> here would not undo. `hidden` is
 * the native attribute, so no design-system class names live in JS.
 */
export default class extends Controller {
  static targets = ["preset", "field", "gate"]

  connect() {
    this.sync()
  }

  sync() {
    const custom = this.presetTarget.value === "custom"
    this.fieldTarget.hidden = !custom
    this.gateTarget.disabled = !custom
  }
}
